/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SituazioneCommesseResponseDTO
 */
export interface SituazioneCommesseResponseDTO {
    /**
     * 
     * @type {number}
     * @memberof SituazioneCommesseResponseDTO
     */
    idLavoro?: number;
    /**
     * 
     * @type {string}
     * @memberof SituazioneCommesseResponseDTO
     */
    personale?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof SituazioneCommesseResponseDTO
     */
    data?: Date;
    /**
     * 
     * @type {string}
     * @memberof SituazioneCommesseResponseDTO
     */
    commessa?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SituazioneCommesseResponseDTO
     */
    note?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SituazioneCommesseResponseDTO
     */
    oreLavorate?: number;
}

/**
 * Check if a given object implements the SituazioneCommesseResponseDTO interface.
 */
export function instanceOfSituazioneCommesseResponseDTO(value: object): value is SituazioneCommesseResponseDTO {
    return true;
}

export function SituazioneCommesseResponseDTOFromJSON(json: any): SituazioneCommesseResponseDTO {
    return SituazioneCommesseResponseDTOFromJSONTyped(json, false);
}

export function SituazioneCommesseResponseDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): SituazioneCommesseResponseDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'idLavoro': json['idLavoro'] == null ? undefined : json['idLavoro'],
        'personale': json['personale'] == null ? undefined : json['personale'],
        'data': json['data'] == null ? undefined : (new Date(json['data'])),
        'commessa': json['commessa'] == null ? undefined : json['commessa'],
        'note': json['note'] == null ? undefined : json['note'],
        'oreLavorate': json['oreLavorate'] == null ? undefined : json['oreLavorate'],
    };
}

export function SituazioneCommesseResponseDTOToJSON(json: any): SituazioneCommesseResponseDTO {
    return SituazioneCommesseResponseDTOToJSONTyped(json, false);
}

export function SituazioneCommesseResponseDTOToJSONTyped(value?: SituazioneCommesseResponseDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'idLavoro': value['idLavoro'],
        'personale': value['personale'],
        'data': value['data'] == null ? undefined : ((value['data']).toISOString()),
        'commessa': value['commessa'],
        'note': value['note'],
        'oreLavorate': value['oreLavorate'],
    };
}

